import { render, staticRenderFns } from "./FiltrosRecargos.vue?vue&type=template&id=485ba578"
import script from "./FiltrosRecargos.vue?vue&type=script&lang=js"
export * from "./FiltrosRecargos.vue?vue&type=script&lang=js"
import style0 from "./FiltrosRecargos.vue?vue&type=style&index=0&id=485ba578&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports